import { cn } from '@repo/lib/cn';
import { CheckIcon, CopyIcon, TrashIcon } from 'lucide-react';
import { useEffect, useRef, useState } from 'react';

import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { useQuestionTranslateAnswersForm } from '@/hooks/questions';

import { type QuestionTranslateFormAnswersProps } from '.';

export function QuestionTranslateFormAnswers(questionTranslateFormAnswersProps: QuestionTranslateFormAnswersProps) {
  const { answerIndex, onRemove, onCopy } = questionTranslateFormAnswersProps;
  const [copied, setCopied] = useState<boolean>(false);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  const { getAnswerOptions } = useQuestionTranslateAnswersForm(answerIndex);

  const handleRemoveAnswer = () => {
    onRemove(answerIndex);
  };
  const handleCopyAnswer = () => {
    setCopied(true);
    timeoutRef.current = setTimeout(() => setCopied(false), 850);
    onCopy(getAnswerOptions());
  };

  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  return (
    <div className="bg-card flex items-center gap-3 rounded-lg border p-2">
      <div className="flex flex-wrap gap-2">
        {getAnswerOptions().map((option, index) => (
          <Badge key={index} variant={'muted'}>
            {option.content}
          </Badge>
        ))}
      </div>
      <div className="ml-auto flex gap-0.5">
        <Button variant="ghost" size={'sm'} className="disabled:opacity-100" onClick={handleCopyAnswer} disabled={copied}>
          <div className={cn('transition-all', copied ? 'scale-100 opacity-100' : 'scale-0 opacity-0')}>
            <CheckIcon className="text-success" aria-hidden="true" />
          </div>
          <div className={cn('absolute transition-all', copied ? 'scale-0 opacity-0' : 'scale-100 opacity-100')}>
            <CopyIcon aria-hidden="true" className="text-muted-foreground" />
          </div>
        </Button>
        <Button type="button" variant={'ghost'} size={'sm'} onClick={handleRemoveAnswer}>
          <TrashIcon />
        </Button>
      </div>
    </div>
  );
}
